// extracted by mini-css-extract-plugin
module.exports = {"initials":"Initials_initials__9N2RW","small":"Initials_small__DUXeq","large":"Initials_large__8EfA1"};